import React from 'react';
import { NavLink } from 'react-router-dom';
import { IconHome, IconSettings, IconCalendar } from './Icons.jsx';
import { useApi } from '../hooks/useApi.js';
import { TopHat } from './HatBalance.jsx';

const TABS = [
  { to: '/', label: 'Home', Icon: IconHome, exact: true },
  { to: '/business', label: 'Employee', Icon: IconCalendar },
  { to: '/settings', label: 'Settings', Icon: IconSettings },
];

export default function TabBar() {
  const { data } = useApi('/growth/capabilities');
  const tabs = data?.enabled ? [...TABS.slice(0, -1), { to: '/growth', label: 'HAT', Icon: TopHat }, ...TABS.slice(-1)] : TABS;
  return (
    <nav className="tab-bar" role="navigation" aria-label="Main navigation">
      {/* Desktop-only logo — matches hireaigo.com brand */}
      <div className="tab-bar-logo" aria-hidden="true">
        <img src="https://hireaigo.com/aigo-icon.svg?v=3" alt="" style={{ width: 28, height: 28, flexShrink: 0 }} />
        <span style={{ fontWeight: 800, fontSize: 17, letterSpacing: '-0.5px', color: '#fff' }}>HireAiGO</span>
      </div>

      {tabs.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.exact}
          className={({ isActive }) => `tab-item${isActive ? ' active' : ''}`}
          role="tab"
        >
          <tab.Icon size={22} aria-hidden="true" />
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
